import { useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router";

import { Context } from "../../models/context";
import PermissionGuard from "../permissionGuard/PermissionGuard";
import "./nav.css";

const LOGIN_PAGE = { name: "Login", path: "/login" };

interface NavItem {
    name: string;
    path: string;
    scopes?: string[];
}

export default function Nav({ pages }: { pages: NavItem[] }) {
    const context = useContext(Context);
    const location = useLocation();
    const [effectivePages, setEffectivePages] = useState(pages);

    const loggedIn = context.user ? true : false;

    useEffect(() => {
        if (!loggedIn){
            let loginItem = {...LOGIN_PAGE};
            loginItem.path+=`?entryPoint=${window.location.pathname}`;
            setEffectivePages([loginItem]);
        }
        else setEffectivePages(pages);
        console.log(effectivePages);
    }, [location]);

    return (<nav id="nav">
        <div id="nav-title">
            <img src="/images/gspurt_crop_white.png" alt="GrowthSpurt Logo" id="nav-logo" className="nav-link" />
            {loggedIn ? <NavLink to="/"><h1 id="nav-title-text">Growth Spurt</h1></NavLink> : <h1 id="nav-title-text">Growth Spurt</h1>}
        </div>
        <div id="nav-link-wrapper">
            {effectivePages.map((page) => (
                <PermissionGuard requiredScopes={page.scopes} key={page.path}>
                    <NavLink 
                        to={page.path} 
                        key={page.path}
                        className="nav-link"
                    >
                        {page.name}
                    </NavLink>
                </PermissionGuard>
            ))}
        </div>
    </nav>);
}
